<form *ngIf='form as form' [formGroup]='form' autocomplete='off' novalidate>
  <div class="row">
    <div class="col-12">
      <fieldset>
        <legend>
          {{ label }}
        </legend>
        <br>
        <div class='row'>
          <div class='col-md-4'>
            <div class='form-group' *ngIf='"startDate" as controlName'>
              <label [for]='controlName'>
                Data od *
              </label>
              <app-date-picker (change)="form.startDateChange($event)" [id]='controlName'
                               [formControlName]='controlName'>
              </app-date-picker>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
          <div class='col-md-4'>
            <div class='form-group' *ngIf='"endDate" as controlName'>
              <label [for]='controlName'>
                Data do *
              </label>
              <app-date-picker (change)="form.endDateChange($event)" [id]='controlName' [formControlName]='controlName'>
              </app-date-picker>
              <app-validation-errors fieldLabel='Data od' secondFieldLabel='dacie do' [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
          <div class="col-md-4">
            <div class='form-group' *ngIf='"dayQuantity" as controlName'>
              <label [for]='controlName'>
                Ilość dni
              </label>
              <input
                readonly
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu ilość dni'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        </div>
        <br>
        <app-alert alertTittle="Uwaga!" [closable]="false">
          <p>Aby powierzchnie zostały wyliczone automatycznie na podstawie narysowanego obszaru:</p>
          <ol class="ms-4 mt-2">
            <li class="mb-2">
              Przejdź do funkcji <strong>GEOMETRIA</strong>
            </li>
            <li class="mb-2">
              Wybierz warstwę <strong>WIELOBOK</strong> i narysuj obszar na mapie.
            </li>
            <li class="mb-2">
              Wyślij geometrię.
            </li>
          </ol>
          <p>Po wysłaniu, w tabeli na końcu wniosku zostaną uzupełnione powierzchnie
            łączne. Sprawdź dane i w razie potrzeby popraw je ręcznie.</p>
        </app-alert>
        <div class="row">
          <div class="col-12">
            <div class='form-group' *ngIf='"infrastructureTelecommunicationOnly" as controlName'>
              <div class='custom-checkbox custom-inline' [ngClass]='{ "is-invalid": form.showError(controlName) }'>
                <input
                  [formControlName]='controlName'
                  type='checkbox'
                  [id]='controlName'
                  [name]='controlName'>
                <label [for]='controlName'>
                  Etap obowiązuje wyłącznie na zajęcie pasa w odniesieniu do obiektów i urządzeń infrastruktury
                  telekomunikacyjnej
                </label>
              </div>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        </div>
        <app-exposed-map-control
          #expMap
          (dictionary)="form.onLoadExposedMapDict($event)"
          [serviceId]="serviceId()"
          [control]="form.geometry">
        </app-exposed-map-control>
        <app-road-controls-set [expMapDict]="expMap.dictEvent()" [form]="form"></app-road-controls-set>
        <fieldset>
          <legend>
            Działki
          </legend>
          <div class="row">
            <div class="col-12">
              <app-parcels-crud [expMapDict]="expMap.dictEvent()" expMapDictPlotType="Drogowa" formControlName="parcels"></app-parcels-crud>
            </div>
          </div>
        </fieldset>
        <br>
        <div class="row">
          <div class="col-12">
            <app-alert alertTittle="Uwaga!" type="info" [closable]="false">
              Wypełnij min <strong>1</strong> z poniższych sekcji.
            </app-alert>
          </div>
        </div>
        <fieldset>
          <legend>
            Do 50% szerokości jezdni
          </legend>
          <div class='row'>
            <div class='col-md-3'>
              <div class='form-group' *ngIf='"roadWidth2" as controlName'>
                <label [for]='controlName'>
                  Szerokość (m)
                </label>
                <input
                  (change)='form.calcRoadArea2()'
                  mask='separator.2'
                  decimalMarker=','
                  [dropSpecialCharacters]='false'
                  [id]='controlName'
                  [ngClass]='{ "is-invalid": form.showError(controlName) }'
                  [formControlName]='controlName'
                  placeholder='Wpisz tu szerokość'
                  type='text'>
                <app-validation-errors [control]='form.get(controlName)'>
                </app-validation-errors>
              </div>
            </div>
            <div class='col-md-3'>
              <div class='form-group' *ngIf='"roadLength2" as controlName'>
                <label [for]='controlName'>
                  Długość (m)
                </label>
                <input
                  (change)='form.calcRoadArea2()'
                  mask='separator.2'
                  decimalMarker=','
                  [dropSpecialCharacters]='false'
                  [id]='controlName'
                  [ngClass]='{ "is-invalid": form.showError(controlName) }'
                  [formControlName]='controlName'
                  placeholder='Wpisz tu długość'
                  type='text'>
                <app-validation-errors [control]='form.get(controlName)'>
                </app-validation-errors>
              </div>
            </div>
            <div class='col-md-3'>
              <div class='form-group' *ngIf='"roadArea2" as controlName'>
                <label [for]='controlName'>
                  Powierzchnia (m<sup>2</sup>)
                </label>
                <input
                  mask='separator.2'
                  decimalMarker=','
                  [dropSpecialCharacters]='false'
                  [id]='controlName'
                  [ngClass]='{ "is-invalid": form.showError(controlName) }'
                  [formControlName]='controlName'
                  placeholder='Powierzchnia'
                  type='text'>
                <app-validation-errors [control]='form.get(controlName)'>
                </app-validation-errors>
              </div>
            </div>
            <div class="col-md-3 d-flex align-items-center">
              <button
                aria-controls="roadWidth2 roadLength2 roadArea2"
                [disabled]="!form.canClearRoad2Controls"
                (click)="form.clearRoad2Controls()"
                title="Wyczyść wiersz"
                class="btn btn-tertiary mb-4 mb-md-0"
                type="button">
                <i class="fa fa-times" aria-hidden="true"></i>Wyczyść
              </button>
            </div>
          </div>
        </fieldset>
        <fieldset>
          <legend>
            Powyżej 50% szerokości jezdni
          </legend>
          <div class='row'>
            <div class='col-md-3'>
              <div class='form-group' *ngIf='"roadWidth3" as controlName'>
                <label [for]='controlName'>
                  Szerokość (m)
                </label>
                <input
                  (change)='form.calcRoadArea3()'
                  mask='separator.2'
                  decimalMarker=','
                  [dropSpecialCharacters]='false'
                  [id]='controlName'
                  [ngClass]='{ "is-invalid": form.showError(controlName) }'
                  [formControlName]='controlName'
                  placeholder='Wpisz tu szerokość'
                  type='text'>
                <app-validation-errors [control]='form.get(controlName)'>
                </app-validation-errors>
              </div>
            </div>
            <div class='col-md-3'>
              <div class='form-group' *ngIf='"roadLength3" as controlName'>
                <label [for]='controlName'>
                  Długość (m)
                </label>
                <input
                  (change)='form.calcRoadArea3()'
                  mask='separator.2'
                  decimalMarker=','
                  [dropSpecialCharacters]='false'
                  [id]='controlName'
                  [ngClass]='{ "is-invalid": form.showError(controlName) }'
                  [formControlName]='controlName'
                  placeholder='Wpisz tu długość'
                  type='text'>
                <app-validation-errors [control]='form.get(controlName)'>
                </app-validation-errors>
              </div>
            </div>
            <div class='col-md-3'>
              <div class='form-group' *ngIf='"roadArea3" as controlName'>
                <label [for]='controlName'>
                  Powierzchnia (m<sup>2</sup>)
                </label>
                <input
                  mask='separator.2'
                  decimalMarker=','
                  [dropSpecialCharacters]='false'
                  [id]='controlName'
                  [ngClass]='{ "is-invalid": form.showError(controlName) }'
                  [formControlName]='controlName'
                  placeholder='Powierzchnia'
                  type='text'>
                <app-validation-errors [control]='form.get(controlName)'>
                </app-validation-errors>
              </div>
            </div>
            <div class="col-md-3 d-flex align-items-center">
              <button
                aria-controls="roadWidth3 roadLength3 roadArea3"
                [disabled]="!form.canClearRoad3Controls"
                (click)="form.clearRoad3Controls()"
                title="Wyczyść wiersz"
                class="btn btn-tertiary mb-4 mb-md-0"
                type="button">
                <i class="fa fa-times" aria-hidden="true"></i>Wyczyść
              </button>
            </div>
          </div>
        </fieldset>
        <fieldset>
          <legend>
            Powierzchnia chodnika, zatoki postojowej, parkingu, ścieżki rowerowej
          </legend>
          <div class='row'>
            <div class='col-md-3'>
              <div class='form-group' *ngIf='"sidewalkWidth" as controlName'>
                <label [for]='controlName'>
                  Szerokość (m)
                </label>
                <input
                  (change)='form.calcSidewalkArea()'
                  mask='separator.2'
                  decimalMarker=','
                  [dropSpecialCharacters]='false'
                  [id]='controlName'
                  [ngClass]='{ "is-invalid": form.showError(controlName) }'
                  [formControlName]='controlName'
                  placeholder='Wpisz tu szerokość'
                  type='text'>
                <app-validation-errors [control]='form.get(controlName)'>
                </app-validation-errors>
              </div>
            </div>
            <div class='col-md-3'>
              <div class='form-group' *ngIf='"sidewalkLength" as controlName'>
                <label [for]='controlName'>
                  Długość (m)
                </label>
                <input
                  (change)='form.calcSidewalkArea()'
                  mask='separator.2'
                  decimalMarker=','
                  [dropSpecialCharacters]='false'
                  [id]='controlName'
                  [ngClass]='{ "is-invalid": form.showError(controlName) }'
                  [formControlName]='controlName'
                  placeholder='Wpisz tu długość'
                  type='text'>
                <app-validation-errors [control]='form.get(controlName)'>
                </app-validation-errors>
              </div>
            </div>
            <div class='col-md-3'>
              <div class='form-group' *ngIf='"sidewalkArea" as controlName'>
                <label [for]='controlName'>
                  Powierzchnia (m<sup>2</sup>)
                </label>
                <input
                  mask='separator.2'
                  decimalMarker=','
                  [dropSpecialCharacters]='false'
                  [id]='controlName'
                  [ngClass]='{ "is-invalid": form.showError(controlName) }'
                  [formControlName]='controlName'
                  placeholder='Powierzchnia'
                  type='text'>
                <app-validation-errors [control]='form.get(controlName)'>
                </app-validation-errors>
              </div>
            </div>
            <div class="col-md-3 d-flex align-items-center">
              <button
                aria-controls="sidewalkWidth sidewalkLength sidewalkArea"
                [disabled]="!form.canClearSidewalkControls"
                (click)="form.clearSidewalkControls()"
                title="Wyczyść wiersz"
                class="btn btn-tertiary mb-4 mb-md-0"
                type="button">
                <i class="fa fa-times" aria-hidden="true"></i>Wyczyść
              </button>
            </div>
          </div>
        </fieldset>
        <fieldset>
          <legend>
            Powierzchnia pozostałych elementów pasa drogowego (zieleni, rowu, pobocza)
          </legend>
          <div class='row'>
            <div class='col-md-3'>
              <div class='form-group' *ngIf='"otherElementsWidth" as controlName'>
                <label [for]='controlName'>
                  Szerokość (m)
                </label>
                <input
                  (change)='form.calcOtherElementsArea()'
                  mask='separator.2'
                  decimalMarker=','
                  [dropSpecialCharacters]='false'
                  [id]='controlName'
                  [ngClass]='{ "is-invalid": form.showError(controlName) }'
                  [formControlName]='controlName'
                  placeholder='Wpisz tu szerokość'
                  type='text'>
                <app-validation-errors [control]='form.get(controlName)'>
                </app-validation-errors>
              </div>
            </div>
            <div class='col-md-3'>
              <div class='form-group' *ngIf='"otherElementsLength" as controlName'>
                <label [for]='controlName'>
                  Długość (m)
                </label>
                <input
                  (change)='form.calcOtherElementsArea()'
                  mask='separator.2'
                  decimalMarker=','
                  [dropSpecialCharacters]='false'
                  [id]='controlName'
                  [ngClass]='{ "is-invalid": form.showError(controlName) }'
                  [formControlName]='controlName'
                  placeholder='Wpisz tu długość'
                  type='text'>
                <app-validation-errors [control]='form.get(controlName)'>
                </app-validation-errors>
              </div>
            </div>
            <div class='col-md-3'>
              <div class='form-group' *ngIf='"otherElementsArea" as controlName'>
                <label [for]='controlName'>
                  Powierzchnia (m<sup>2</sup>)
                </label>
                <input
                  mask='separator.2'
                  decimalMarker=','
                  [dropSpecialCharacters]='false'
                  [id]='controlName'
                  [ngClass]='{ "is-invalid": form.showError(controlName) }'
                  [formControlName]='controlName'
                  placeholder='Powierzchnia'
                  type='text'>
                <app-validation-errors [control]='form.get(controlName)'>
                </app-validation-errors>
              </div>
            </div>
            <div class="col-md-3 d-flex align-items-center">
              <button
                aria-controls="otherElementsWidth otherElementsLength otherElementsArea"
                [disabled]="!form.canClearOtherElementsControls"
                (click)="form.clearOtherElementsControls()"
                title="Wyczyść wiersz"
                class="btn btn-tertiary mb-4 mb-md-0"
                type="button">
                <i class="fa fa-times" aria-hidden="true"></i>Wyczyść
              </button>
            </div>
          </div>
        </fieldset>
        <fieldset>
          <legend>Powierzchnia w odniesieniu do obiektów i urządzeń infrastruktury telekomunikacyjnej</legend>
          <div class='row'>
            <div class='col-md-3'>
              <div class='form-group' *ngIf='"roadWidth" as controlName'>
                <label [for]='controlName'>
                  Szerokość (m)
                </label>
                <input
                  (change)='form.calcRoadArea()'
                  mask='separator.2'
                  decimalMarker=','
                  [dropSpecialCharacters]='false'
                  [id]='controlName'
                  [ngClass]='{ "is-invalid": form.showError(controlName) }'
                  [formControlName]='controlName'
                  placeholder='Wpisz tu szerokość'
                  type='text'>
                <app-validation-errors [control]='form.get(controlName)'>
                </app-validation-errors>
              </div>
            </div>
            <div class='col-md-3'>
              <div class='form-group' *ngIf='"roadLength" as controlName'>
                <label [for]='controlName'>
                  Długość (m)
                </label>
                <input
                  (change)='form.calcRoadArea()'
                  mask='separator.2'
                  decimalMarker=','
                  [dropSpecialCharacters]='false'
                  [id]='controlName'
                  [ngClass]='{ "is-invalid": form.showError(controlName) }'
                  [formControlName]='controlName'
                  placeholder='Wpisz tu długość'
                  type='text'>
                <app-validation-errors [control]='form.get(controlName)'>
                </app-validation-errors>
              </div>
            </div>
            <div class='col-md-3'>
              <div class='form-group' *ngIf='"roadArea" as controlName'>
                <label [for]='controlName'>
                  Powierzchnia (m<sup>2</sup>)
                </label>
                <input
                  mask='separator.2'
                  decimalMarker=','
                  [dropSpecialCharacters]='false'
                  [id]='controlName'
                  [ngClass]='{ "is-invalid": form.showError(controlName) }'
                  [formControlName]='controlName'
                  placeholder='Powierzchnia'
                  type='text'>
                <app-validation-errors [control]='form.get(controlName)'>
                </app-validation-errors>
              </div>
            </div>
            <div class="col-md-3 d-flex align-items-center">
              <button
                aria-controls="roadWidth roadLength roadArea"
                [disabled]="!form.canClearRoadControls"
                (click)="form.clearRoadControls()"
                title="Wyczyść wiersz"
                class="btn btn-tertiary mb-4 mb-md-0"
                type="button">
                <i class="fa fa-times" aria-hidden="true"></i>Wyczyść
              </button>
            </div>
          </div>
        </fieldset>
      </fieldset>
    </div>
  </div>
</form>
